export const validateAccount = (text: string): boolean => {
  // Por el momento no hay más lógica, agregar sí se conoce en el futuro
  return /^\d{8,10}$/.test(text);
};
